import { Component } from 'react'
import { observer } from 'mobx-react'

import * as h from 'h'

import AnimatedFlex from 'components/AnimatedFlex'

import styles from './styles-contacts.scss'

@observer(['AboutStore', 'UiStore'])
export default class Contacts extends Component {
  render () {
    const { UiStore, AboutStore: { visibleContacts } } = this.props

    return h.div(h.ca(styles.container),
      UiStore.inAboutDetailView && h.h(ResetSelectionsButton, {
        onClick: () => UiStore.resetSelectedTagAndContact()
      }),
      h.h(AnimatedFlex, {
        direction: UiStore.inAboutDetailView ? 'column' : 'row',
        animationDuration: 500,
        theme: { column: styles.column, row: styles.row }
      },
        visibleContacts.map(c => h.h(Contact, {
          key: c.name,
          contact: c
        }))
      )
    )
  }
}

@observer(['UiStore'])
class Contact extends Component {
  onAvatarClick () {
    const { UiStore, contact } = this.props

    if (UiStore.selectedTag) {
      /* The spec doesn't say what we should do when the user clicks on an
       * avatar in the detail view, but I think it makes most sense to do
       * nothing. */
      return
    }

    UiStore.selectedContact = UiStore.selectedContact === null
      ? contact
      : null
  }

  render () {
    const { UiStore, contact } = this.props

    const blur = UiStore.hoveredTag &&
      !UiStore.hoveredTag.contacts.some(c => c.id === contact.id)

    return h.div(h.ca(styles.contact, { [styles.blur]: blur }),
      h.img({
        src: contact.image,
        alt: contact.name,
        name: `expand ${contact.name}'s faculty info'`,
        onClick: () => this.onAvatarClick(),
        onMouseOver: () => { UiStore.hoveredContact = contact },
        onMouseOut: () => { UiStore.hoveredContact = null }
      }),
      h.div(h.ca(styles.contactInfo),
        h.h3(h.ca(styles.name), contact.name),
        h.maybe(contact.title, h.p(h.ca(styles.title), contact.title)),
        h.maybe(contact.phone, h.p(h.ca(styles.phone), contact.phone)),
        h.maybe(contact.email, h.p(h.ca(styles.email), contact.email))
      ),
      h.div(h.ca(styles.bio), h.raw({ content: contact.description }))
    )
  }
}

const ResetSelectionsButton = ({ onClick }) => (
  h.z({ ...h.ca(styles.clearButton), onClick },
    '« Return to all contacts'
  )
)



// WEBPACK FOOTER //
// ./resources/assets/js/containers/About/Contacts.js